import { reactive } from "vue";
import { getSearch } from "./gerData";

// 全局搜索状态
const searchState = reactive({
  isSearching: false,
  searchQuery: "",
  searchResults: [],
  loading: false,
  error: null,
  showSearchInput: false,
});

// 搜索相关的方法
const searchMethods = {
  // 设置搜索状态
  setSearching(isSearching) {
    searchState.isSearching = isSearching;
  },

  // 设置搜索输入框显示状态
  setShowSearchInput(show) {
    searchState.showSearchInput = show;
  },

  // 设置搜索关键词
  setSearchQuery(query) {
    searchState.searchQuery = query;
    // 保存到本地存储
    if (query && query.trim()) {
      this.saveSearchQuery(query.trim());
    }
  },

  // 执行搜索
  async performSearch(query) {
    if (!query || !query.trim()) {
      return;
    }

    searchState.loading = true;
    searchState.error = null;
    searchState.searchQuery = query.trim();
    
    // 保存搜索关键词到本地存储
    this.saveSearchQuery(query.trim());

    try {
      const queryParams = {
        title: query.trim(),
      };

      const response = await getSearch(queryParams);

      if (response && response.data) {
        // 处理搜索结果数据
        response.data?.map((item) => {
          item.result_list?.map((cur) => {
            cur.image = cur.image ? `http://api.msam.net.cn/${cur.image}` : undefined
            cur.content = cur.content?.replace(/<[^>]*>/g, '')
            cur.start_time = cur.start_time ? cur.start_time?.slice(0, 4) + '年' + cur.start_time?.slice(5, 7) + '月' + cur?.start_time.slice(8, 10) + '日' : ''
            cur.end_time =  cur.end_time ? cur.end_time?.slice(0, 4) + '年' + cur.end_time?.slice(5, 7) + '月' + cur?.end_time.slice(8, 10) + '日' : ''
            cur.created_at = cur.created_at ? cur.created_at?.slice(0, 4) + '.' + cur.created_at.slice(5, 7) + '.' + cur.created_at.slice(8, 10) : ''
          });
        });

        searchState.searchResults = response.data;
      } else {
        searchState.searchResults = [];
      }
    } catch (error) {
      console.error("搜索失败:", error);
      searchState.error = "搜索失败，请稍后重试";
      searchState.searchResults = [];
    } finally {
      searchState.loading = false;
    }
  },

  // 清空搜索结果
  clearSearch() {
    searchState.searchQuery = "";
    searchState.searchResults = [];
    searchState.error = null;
    searchState.loading = false;
    searchState.isSearching = false;
    searchState.showSearchInput = false;
    // 清除本地存储
    localStorage.removeItem('searchQuery');
  },

  // 保存搜索关键词到本地存储
  saveSearchQuery(query) {
    if (query && query.trim()) {
      localStorage.setItem('searchQuery', query.trim());
    }
  },

  // 从本地存储恢复搜索关键词
  restoreSearchQuery() {
    const savedQuery = localStorage.getItem('searchQuery');
    if (savedQuery) {
      searchState.searchQuery = savedQuery;
      return savedQuery;
    }
    return null;
  },

  // 获取模拟搜索结果（用于演示）
  getMockResults() {
    return [
      {
        id: 1,
        title: "文明的源起——早期中华文明探寻大展",
        titleEn: "THE ORIGIN OF CIVILIZATION",
        content:
          "通过珍贵的文物展品，展现早期中华文明的魅力与深厚底蕴，探寻中华文明的源起与发展脉络。",
        image: "https://picsum.photos/400/300?random=1",
        date: "2024年10月11日（星期五）- 2025年3月31日（星期五）",
        category: "展览",
        location: "一展厅/一层大厅/2A展厅",
        description:
          "本展览汇集了来自全国各地博物馆的珍贵文物，通过考古发现和历史文献，全面展示早期中华文明的起源、发展和特色。",
      },
      {
        id: 2,
        title: "史上最大规模丝绸之路艺术展",
        titleEn: "THE LARGEST SILK ROAD ART EXHIBITION",
        content:
          "展示丝绸之路沿线各国的艺术珍品，呈现东西方文化交流的辉煌历史。",
        image: "https://picsum.photos/400/300?random=2",
        date: "2024年10月11日（星期五）- 2025年3月31日（星期五）",
        category: "展览",
        location: "2A展厅",
        description:
          "本展览展出了来自丝绸之路沿线20多个国家和地区的艺术珍品，包括壁画、雕塑、织物、金银器等。",
      },
      {
        id: 3,
        title: "变动中的中国",
        titleEn: "CHINA IN TRANSITION",
        content: "展现中国近现代历史变迁，反映社会发展的重要节点。",
        image: "https://picsum.photos/400/300?random=3",
        date: "2024年10月11日（星期五）- 2025年3月31日（星期五）",
        category: "展览",
        location: "3A展厅",
        description:
          "通过历史文物、图片资料和多媒体展示，全面反映中国近现代历史的重要变迁。",
      },
    ];
  },
};

// 导出状态和方法
export { searchState, searchMethods };